<auth-forms
  [displayedComponent]="authType" 
  (close)="backToRoot()" 
  (login)="handleLogin()" 
  (register)="handleRegister()"
  (resetPassword)="handleResetPassword()">
</auth-forms>
